import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentLeaderboardItem } from '../../../../services/agent-leaderboard.models';

/**
 * Explains how an agent's leaderboard score was built (vouchers, sales, leave penalty)
 * and where they rank in each zone by sales.
 */
@Component({
  selector: 'app-agent-score-breakdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './agent-score-breakdown.component.html'
})
export class AgentScoreBreakdownComponent {
  @Input({ required: true }) agent!: AgentLeaderboardItem;
}
